import { createSelector } from 'reselect'
import { getInstancesDomainSelector } from 'modules/redux/selectors/domain'
import { REDUX_DOMAIN } from 'modules/redux/constants'

/**
 * Selects whether the Cart has CartProducts.
 * @returns {boolean}
 */
function hasCartProductsSelector () {
  return createSelector(
    getInstancesDomainSelector(REDUX_DOMAIN.CART_PRODUCTS),
    (cartProducts) => cartProducts.length > 0
  )
}

export {
  hasCartProductsSelector
}
